import PropTypes from 'prop-types';
import merge from 'lodash/merge';

import Chart from '../../charts/Chart';
import 'highcharts/modules/bullet';

import { bulletChartConfiguration, setModifiedData } from './utilities/helpers';

const BulletChart = ({ series, xAxis, ...props }) => {
  return (
    <Chart
      options={merge({}, bulletChartConfiguration, {
        series,
        type: 'bullet',
        xAxis,
        ...props,
      })}
      setModifiedData={setModifiedData}
      {...props}
    />
  );
};

BulletChart.propTypes = {
  series: PropTypes.array,
  xAxis: PropTypes.object,
};

export default BulletChart;
